import React from 'react';

interface AnimateAvatarImageProps {
	imgId: string;
}

const AnimateAvatarImage = (props: AnimateAvatarImageProps) => {
	return (
		<div className="animateAvatarImage">
			<svg xmlns="http://www.w3.org/2000/svg" width="181" height="181" viewBox="0 0 181 181" fill="none">
				{/*<circle
					cx="90.25"
					cy="90.166"
					r="88.5"
					fill="#321C5B"
					stroke="url(#paint0_linear_593_31398)"
					strokeWidth="3"
				/>*/}
				<path
					d="M1.75,90.166a88.5,88.5 0 1,0 177,0a88.5,88.5 0 1,0 -177,0"
					fill="#321C5B"
					stroke="url(#paint0_linear_593_31398)"
					strokeWidth="3"
				/>
				<defs>
					<linearGradient id="paint0_linear_593_31398" x1="90.25" y1="0.166016" x2="90.25" y2="180.166" gradientUnits="userSpaceOnUse">
						<stop stopColor="#D6B0FF"/>
						<stop offset="1" stopColor="#A08AFF"/>
					</linearGradient>
				</defs>
			</svg>

		</div>
	);
};

export default AnimateAvatarImage;